import axios from "axios";
import { Confirm } from "notiflix";
import React, { useCallback, useEffect, useState } from "react";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import Modal from "react-modal";
import { useSelector } from "react-redux";
import { Link, useHistory, useParams } from "react-router-dom";
import { _plaka, _serverUrl2 } from "../../../config";
import { failed, success } from "../../../Utils/Alerts";
import { loadingSc, SuccessAlert } from "../../Layout/AlertDiv";
import { addSingleFeatureTotempLayerByXY, tempLayer, zoomToFeatureByXY } from "../../Map/Layers/TempLayer";
import { MyMap } from "../../Map/View/MyMap";
import TaskImageLog from "../Tasks/TaskImageLog";
import TaskLog from "../Tasks/TaskLog";

export default function SignUpdate() {
  const history = useHistory();
  const hSignID = useParams().id;

  const getUserInfo = useSelector((state) => state.getUserInfo);

  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImages, setSelectedImages] = useState([]);

  const [modalVisible, setModalVisible] = useState(false);

  const [selectedTabela, setSelectedTabela] = useState({});
  const [nearRoad, setNearRoad] = useState([]);

  const [info, setInfo] = useState({ resimler: [], levhalar: [] });

  const onClickRemoveTask = async () => {
    let json = {
      kullanici: getUserInfo.Id,
      id: hSignID,
    };
    Confirm.show("Emin misiniz", "Görevi Silmek İstediğinizden Emin Misiniz", "Evet", "Hayır", () => {
      axios
        .post(_serverUrl2 + "/task/remove", json)
        .then((res) => {
          if (res.data.status) {
            success("İşlem Başarılı");
            history.push("/dashboard/task");
          } else {
            failed("Silme işlemi sırasında hata oluştu." + res.data.error);
          }
        })
        .catch((err) => {
          failed("Silme işlemi sırasında hata oluştu." + err);
        });
    });
  };

  const getInfosFromNode = useCallback(async () => {
    loadingSc(true);
    await axios
      .get(_serverUrl2 + "/sign/getWebInfos/" + hSignID)
      .then((res) => {
        if (res.data.status) {
          setInfo(res.data.rows[0].json_build_object.direk_bilgisi);
          zoomToFeatureByXY(res.data.rows[0].json_build_object.direk_bilgisi.x, res.data.rows[0].json_build_object.direk_bilgisi.y);
          addSingleFeatureTotempLayerByXY(res.data.rows[0].json_build_object.direk_bilgisi.x, res.data.rows[0].json_build_object.direk_bilgisi.y);
          document.getElementById("kontrol_durum").value = res.data.rows[0].json_build_object.direk_bilgisi.kontrol_durum;
          document.getElementById("kontrol_aciklama").value = res.data.rows[0].json_build_object.direk_bilgisi.kontrol_aciklama;
        } else {
          failed("Veriler Getirilemedi");
        }
      })
      .catch(() => {
        failed("Veriler Getirilemedi");
      });

    loadingSc(false);
  }, [hSignID]);

  const onClickKurumKontrolKayit = async () => {
    //
    // SADECE HATALI VE UYGUN SEÇİLMİŞSE DEVAM ETMELİ
    //
    if (document.getElementById("kontrol_durum").value == "UYGUN" || document.getElementById("kontrol_durum").value == "HATALI") {
      let json = {
        tip: 3,
        kontrol_durum: document.getElementById("kontrol_durum").value,
        kontrol_aciklama: document.getElementById("kontrol_aciklama").value,
        kontrol_yapan_kullanici: getUserInfo.Id,
        kontrol_tarihi: new Date(),
        id: hSignID,
      };
      await axios.post(_serverUrl2 + "/organization/update", json).then((res) => {
        if (res.data.status) {
          alert("Kurum Kontrol Bilgisi Yapıldı!");
          return;
        }
        alert("İşlem başarısız.");
      });
      console.log(json);
    } else {
      return;
    }
  };

  const onChangeFile = async (e) => {
    let fromData = new FormData();
    let selectedFile = e.target.files[0];

    fromData.append("file", selectedFile);
    fromData.append("gorev_id", hSignID);
    fromData.append("plaka_kod", _plaka);
    fromData.append("kayit_tarihi", new Date().toISOString().split("T")[0]);
    fromData.append("ekleyen_kullanici", getUserInfo.Id);
    fromData.append("tip", 6);

    await axios
      .post(_serverUrl2 + "/main/addImage", fromData)
      .then(() => {
        SuccessAlert("Resim Eklendi");
        getInfosFromNode();
      })
      .catch(() => {});
  };

  const onClickDeleteImage = async (d, tip) => {
    console.log('tip', tip, 'hSignID', hSignID, 'd.id', d.id);
    Confirm.show("Emin misiniz", "Resimi Silmek İstediğinizden Emin Misiniz", "Evet", "Hayır", async () => {
      await axios.get(_serverUrl2 + "/main/deleteImage/" + tip + "/" + hSignID + "/" + d.id).then(() => {
        success("Resim Silindi!");
        getInfosFromNode();
      });
    });
  };

  const onClickUpdateLevha = async (data) => {
    setSelectedTabela(data);
    await axios.get(_serverUrl2 + "/sign/getNearRoads/" + hSignID).then((res) => {
      setModalVisible(true);
      setNearRoad(res.data.rows);
    });
  };

  const onClickDeleteLevha = (id) => {
    Confirm.show("Emin misiniz", "Levhayı Silmek İstediğinizden Emin Misiniz", "Evet", "Hayır", async () => {
      await axios.post(_serverUrl2 + "/sign/delete", { id: id }).then(() => {
        success("Levha Silindi!");
        getInfosFromNode();
      });
    });
  };

  const onSubmitUpdateTabela = async () => {
    console.log(selectedTabela);

    if (nearRoad.find((d) => d.ad == selectedTabela.adi) == null) {
      failed("Geçerli bir yol ile ilişki kurulduğundan emin olunuz.");
      return;
    }

    let json = {
      id: selectedTabela.id,
      adi: selectedTabela.adi,
      yon_tip: selectedTabela.yon_tipi,
      islem_durum: selectedTabela.islem_durum,
      aciklama: selectedTabela.aciklama,
      son_guncelleme_tarihi: new Date(),
      ekleyen_kullanici: getUserInfo.Id,
      maks_yol_kn: nearRoad.find((d) => d.ad == selectedTabela.adi).maks_kimlik_no,
      direkduvar_id: hSignID,
    };
    await axios
      .post(_serverUrl2 + "/sign/plate/addUpdate", json)
      .then((res) => {
        if (res.data.status) {
          success("Tabela bilgileri güncellendi.");
          getInfosFromNode();
        } else {
          failed("Hata oluştu.");
        }
      })
      .catch(() => {
        failed("Hata oluştu.");
      });

    console.log(json);
  };

  useEffect(() => {
    MyMap.addLayer(tempLayer);
    getInfosFromNode();
    return () => {
      MyMap.removeLayer(tempLayer);
      tempLayer.getSource().clear();
    };
  }, [hSignID, getInfosFromNode]);

  return (
    <div className="row">
      <div className="col-sm-12">
        <div className="textBox">
          <div className="content d-flex justify-content-between">
            <button className="orangeBtn" style={{ fontSize: "13px", width: "30px" }} onClick={() => history.goBack()}>
              <i className="fas fa-arrow-left"></i>
            </button>
            <b>Direk/Duvara Ait Levha Bilgileri</b>
            <b>&nbsp;</b>
          </div>
        </div>
      </div>
      <div className="col-sm-12">
        <div className="textBox" style={{ textAlign: "left" }}>
          <div className="row">
            <div className="col-sm-12">
              <hr style={{ margin: "10px" }} />
            </div>

            <div className="col-sm-12" style={{ padding: "5px 20px" }}>
              <div className="textBox" style={{ textAlign: "left", borderLeft: "10px solid rgba(82, 138, 174,1)" }}>
                <div className="content" style={{ textAlign: "left", padding: "15px", backgroundColor: "rgba(82, 138, 174,0.06)" }}>
                  <div className="row">
                    <div className="col-sm-12">
                      <table className="table table-sm table-bordered" style={{ fontSize: "15px" }}>
                        <tbody style={{ fontSize: "13px" }}>
                          <tr>
                            <th colSpan={4} style={{ backgroundColor: "rgba(82, 138, 174,1)", color: "white", fontSize: "15px" }}>
                              <center>Direk/Duvar Bilgileri </center>{" "}
                            </th>
                            <td style={{ backgroundColor: "rgba(82, 138, 174,1)" }}>
                              {" "}
                              {hSignID != 0 && (
                                <div className="col-sm-4">
                                  <TaskLog tip={3} id={hSignID} />
                                  {info.gorev_durum == "ISLEMDE" && getUserInfo.Rol.includes("1") && (
                                    <button className="redBtn" style={{ fontSize: "13px", width: "100px" }} onClick={() => onClickRemoveTask()}>
                                      Görevi Sil
                                    </button>
                                  )}
                                </div>
                              )}
                            </td>
                          </tr>

                          <tr>
                            <th>Tip</th>
                            <td colSpan={3}>{info.tip}</td>
                            <td>
                              <b style={{ fontWeight: "bold" }}>Direk ID :</b> {info.direk_id}
                            </td>
                          </tr>
                          <tr>
                            <th>Son Güncelleyen Kullanıcı</th>
                            <td colSpan={2}>
                              <Link to={"/dashboard/kullaniciDetay/" + info.son_guncelleyen_kullanici}>{info.son_guncelleyen_kullanici}</Link>
                            </td>
                            <th>Son Güncellenme Tarihi</th>
                            <td>{info.son_guncellenme_tarihi}</td>
                          </tr>
                          <tr>
                            <th>İşlem Durumu</th>
                            <td colSpan={4}>{info.islem_durum}</td>
                          </tr>
                          <tr>
                            <th>Saha Açıklaması</th>
                            <td colSpan={4}>{info.aciklama}</td>
                          </tr>
                          <tr>
                            <th>Sahadan Çekilen Resimler</th>
                            <td colSpan={4}>
                              {info.resimler != null && (
                                <div
                                  className="d-flex"
                                  style={{ display: "flex", flexWrap: "wrap", padding: "5px", width: "100%", gridTemplateColumns: "repeat(6, 1fr)" }}
                                >
                                  {info.resimler.map((d, i) => {
                                    return (
                                      <div className="d-flex" style={{ width: "130px", flexDirection: "column", position: "relative" }}>
                                        <img
                                          alt="Sahadan Çekilen Resim"
                                          src={d.resim_path}
                                          style={{ borderRadius: "17px", width: "130px", height: "130px", padding: "5px", cursor: "pointer" }}
                                          width={"130px"}
                                          onClick={() => {
                                            setSelectedImages(
                                              info.resimler.map((d) => {
                                                return d.resim_path;
                                              })
                                            );
                                            setSelectedImage(i);
                                          }}
                                        />
                                        <div className="d-flex justify-content-between">
                                          {getUserInfo.Rol.includes("3") && (
                                            <button
                                              className="redBtn"
                                              style={{ fontSize: "11px", width: "40px", position: "absolute", bottom: "5px", left: "5px" }}
                                              onClick={() => onClickDeleteImage(d, 3)}
                                            >
                                              <i className="fas fa-trash"></i>
                                            </button>
                                          )}
                                          <TaskImageLog id={d.id} />
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <table className="table table-sm table-bordered" style={{ fontSize: "15px" }}>
                        <thead>
                          <tr>
                            <th style={{ backgroundColor: "rgba(82, 138, 174,1)", color: "white" }} colSpan={7}>
                              <center>Direk Duvara Bağlı Tabelalar</center>
                            </th>
                          </tr>
                        </thead>
                        {info.levhalar != null &&
                          info.levhalar.map((d, i2) => {
                            return (
                              <tbody style={{ fontSize: "13px" }}>
                                <tr>
                                  <th>Adı</th>
                                  <td>{d.adi}</td>
                                  <th>İşlem Durum</th>
                                  <td>{d.islem_durum}</td>
                                  <th>ID</th>
                                  <td>{d.id}</td>
                                  <td style={{ width: "72px" }}>
                                    {getUserInfo.Rol.includes("2") && (
                                      <div className="d-flex justify-content-end">
                                        <button className="orangeBtn" style={{ width: "35px", padding: "1px" }} onClick={() => onClickUpdateLevha(d)}>
                                          <i className="fas fa-edit"></i>
                                        </button>
                                        &nbsp;
                                        <button className="redBtn" style={{ width: "35px", padding: "1px" }} onClick={() => onClickDeleteLevha(d.id)}>
                                          <i className="fas fa-trash"></i>
                                        </button>
                                      </div>
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <th>Yön Tipi</th>
                                  <td colSpan={6}>{d.yon_tipi}</td>
                                </tr>
                                <tr>
                                  <th>Açıklama</th>
                                  <td colSpan={6}>{d.aciklama}</td>
                                </tr>
                                <tr>
                                  <th>Resimler</th>
                                  <td colSpan={6}>
                                    {d.resimler != null && (
                                      <div className="d-flex" style={{ flexDirection: "row", padding: "5px", maxWidth: "100%", overflowX: "scroll" }}>
                                        {d.resimler.map((x, i) => {
                                          return (
                                            <div className="d-flex" style={{ flexDirection: "column", position: "relative" }}>
                                              <img
                                                alt="Resim"
                                                src={x.resim_path}
                                                style={{ borderRadius: "17px", width: "130px", height: "130px", padding: "5px", cursor: "pointer" }}
                                                onClick={() => {
                                                  setSelectedImages(
                                                    info.levhalar[i2].resimler.map((z) => {
                                                      return z.resim_path;
                                                    })
                                                  );
                                                  setSelectedImage(i);
                                                }}
                                              />
                                              <div>
                                                <TaskImageLog id={x.id} />
                                              </div>
                                            </div>
                                          );
                                        })}
                                      </div>
                                    )}
                                  </td>
                                </tr>
                              </tbody>
                            );
                          })}
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-sm-12" style={{ padding: "5px 20px" }}>
              <div className="textBox" style={{ textAlign: "left", borderLeft: "10px solid rgba(255,165,0,1)", backgroundColor: "rgba(255,165,0,0.05)" }}>
                <div className="content" style={{ textAlign: "left", padding: "15px", backgroundColor: "rgba(255,165,0,0.05)" }}>
                  <div className="row">
                    <div className="col-sm-12">
                      <table className="table table-sm table-bordered" style={{ fontSize: "12px" }}>
                        <tbody>
                          <tr>
                            <th colSpan={4} style={{ fontSize: "15px", backgroundColor: "rgba(255,165,0,1)" }}>
                              <center>Kurum Kontrolü</center>
                            </th>
                          </tr>
                          <tr>
                            <th>Kontrolü Yapan Kullanıcı</th>
                            <td>{info.kontrol_yapan_kullanici}</td>
                            <th>Kontrol Tarihi</th>
                            <td>{info.kontrol_tarihi}</td>
                          </tr>
                          <tr>
                            <th>Kontrol Durumu</th>
                            <td>
                              <select
                                colSpan={3}
                                id="kontrol_durum"
                                style={{ borderLeft: "3px solid orange", fontSize: "13px", backgroundColor: "#fffaf2" }}
                                className="form-control form-select selectStyle"
                              >
                                <option>UYGUN</option>
                                <option>HATALI</option>
                                <option disabled>BEKLEMEDE</option>
                              </select>
                            </td>
                          </tr>
                          <tr>
                            <th>Kontrol Açıklaması</th>
                            <td colSpan={4}>
                              <input
                                id="kontrol_aciklama"
                                className="form-control form-control-sm"
                                style={{ borderLeft: "3px solid orange", fontSize: "13px", backgroundColor: "#fffaf2" }}
                              ></input>
                            </td>
                          </tr>
                          <tr>
                            <th>Kontrol Resimleri</th>
                            <td colSpan={3}>
                              <input type="file" accept="image/*" className="form-control form-control-sm" onChange={(e) => onChangeFile(e)} />
                              {info.kurum_resimler != null && (
                                <>
                                  <div className="d-flex" style={{ flexDirection: "row", padding: "5px", maxWidth: "100%", overflowX: "scroll" }}>
                                    {info.kurum_resimler.map((d, i) => {
                                      return (
                                        <div className="d-flex" style={{ flexDirection: "column", position: "relative" }}>
                                          <img
                                            alt="Kontrol Resmi"
                                            src={d.resim_path}
                                            style={{ borderRadius: "17px", width: "130px", height: "130px", padding: "5px", cursor: "pointer" }}
                                            onClick={() => {
                                              setSelectedImages(
                                                info.kurum_resimler.map((d) => {
                                                  return d.resim_path;
                                                })
                                              );
                                              setSelectedImage(i);
                                            }}
                                          />
                                          <div className="d-flex justify-content-between">
                                            {getUserInfo.Rol.includes("3") && (
                                              <button
                                                className="redBtn"
                                                style={{ fontSize: "11px", width: "40px", position: "absolute", bottom: "5px", left: "5px" }}
                                                onClick={() => onClickDeleteImage(d, 6)}
                                              >
                                                <i className="fas fa-trash"></i>
                                              </button>
                                            )}
                                            <TaskImageLog id={d.id} />
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </>
                              )}
                            </td>
                          </tr>

                          <tr>
                            <td colSpan={2}></td>
                            {getUserInfo.Rol.includes("2") && (
                              <td colSpan={2}>
                                <button className="btn btn-success btn-sm form-control" onClick={() => onClickKurumKontrolKayit()}>
                                  Kaydet
                                </button>
                              </td>
                            )}
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {selectedImages.length !== 0 ? (
        <Lightbox
          mainSrc={selectedImages[selectedImage]}
          nextSrc={selectedImages[(selectedImage + 1) % selectedImages.length]}
          prevSrc={selectedImages[(selectedImage + selectedImages.length - 1) % selectedImages.length]}
          onCloseRequest={() => setSelectedImages([])}
          onMovePrevRequest={() => setSelectedImage((selectedImage + selectedImages.length - 1) % selectedImages.length)}
          onMoveNextRequest={() => setSelectedImage((selectedImage + selectedImages.length + 1) % selectedImages.length)}
        />
      ) : null}

      <Modal isOpen={modalVisible} contentLabel="Tabela Düzenle" closeTimeoutMS={200} style={customStyles}>
        <div className="row">
          <div className="col-12">
            <h5>Tabela Bilgileri</h5>
            <hr style={{ margin: "2px" }} />
          </div>
          <div className="col-sm-8" style={{ marginBottom: "10px" }}>
            <label>Adı (İlişkilendirileceği Yol)</label>
            <select className="form-control form-select" value={selectedTabela.adi} onChange={(e) => setSelectedTabela({ ...selectedTabela, adi: e.target.value })}>
              <option value="0">Seçilmedi</option>
              {nearRoad.map((d, i) => {
                return (
                  <option key={i} value={d.ad}>
                    {d.ad}
                  </option>
                );
              })}
            </select>
          </div>
          <div className="col-sm-4" style={{ marginBottom: "10px" }}>
            <label>İşlem Durum</label>
            <select
              className="form-control form-select"
              value={selectedTabela.islem_durum}
              onChange={(e) => setSelectedTabela({ ...selectedTabela, islem_durum: e.target.value })}
            >
              <option>YAPILMADI</option>
              <option>TAKILDI</option>
              <option>TAKILAMADI</option>
            </select>
          </div>
          <div className="col-sm-6" style={{ marginBottom: "10px" }}>
            <label>Yön Tipi</label>
            <select
              value={selectedTabela.yon_tipi}
              onChange={(e) => setSelectedTabela({ ...selectedTabela, yon_tipi: e.target.value })}
              className="form-control form-select"
            >
              {["SAĞ BAŞLANGIÇ", "SAĞ BİTİŞ", "SOL BAŞLANGIÇ", "SOL BİTİŞ", "ÇİFT YÖN"].map((d) => {
                return <option>{d}</option>;
              })}
            </select>
          </div>
          <div className="col-sm-12" style={{ marginBottom: "10px" }}>
            <label>Açıklama</label>
            <textarea
              value={selectedTabela.aciklama}
              onChange={(e) => setSelectedTabela({ ...selectedTabela, aciklama: e.target.value })}
              className="form-control form-control-sm"
            />
          </div>
          <div className="col-sm-3">
            <button style={{ fontSize: "12px" }} className="darkOrangeBtn" onClick={() => setModalVisible(false)}>
              Geri
            </button>
          </div>
          <div className="col-sm-1">&nbsp;</div>
          <div className="col-sm-4"></div>
          <div className="col-sm-4">
            <button style={{ fontSize: "12px" }} className="greenBtn" onClick={() => onSubmitUpdateTabela()}>
              Kaydet
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

const customStyles = {
  content: {
    backdropFilter: "blur(10px)",
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "551px",
    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
  },
  overlay: {
    backdropFilter: "blur(2px)",
    backgroundColor: "rgba(0, 0, 0, 0.10)",
  },
};
